import { render, staticRenderFns } from "./banRoleByIp.vue?vue&type=template&id=5ff53736&"
import script from "./banRoleByIp.vue?vue&type=script&lang=js&"
export * from "./banRoleByIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff53736')) {
      api.createRecord('5ff53736', component.options)
    } else {
      api.reload('5ff53736', component.options)
    }
    module.hot.accept("./banRoleByIp.vue?vue&type=template&id=5ff53736&", function () {
      api.rerender('5ff53736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banRoleByIp.vue"
export default component.exports